import React, { Component } from 'react';
import SVGInline from 'react-svg-inline';

const preURLs = {
	facebook: 'https://www.facebook.com/sharer.php?u=',
	twitter: 'https://twitter.com/intent/tweet?url=',
	google: 'https://plus.google.com/share?url=',
	whatsapp: 'whatsapp://send?text='
};

export default class Social extends Component {
	constructor(props) {
		super(props);
		this.state = {
			currentUrl: '',
			finalURL: '',
			windowWidth: '',
			windowHeight: ''
		};
		this.openShareWindow = this.openShareWindow.bind(this);
		this.onClickFacebook = this.onClickFacebook.bind(this);
		this.onClickGoogle = this.onClickGoogle.bind(this);
		this.onClickWhatsapp = this.onClickWhatsapp.bind(this);
		this.onClickTwitter = this.onClickTwitter.bind(this);
	}
	componentDidMount() {
		this.setState({
			currentUrl: window.location.href,
			windowWidth:
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth,
			windowHeight:
				window.innerHeight ||
				document.documentElement.clientHeight ||
				document.body.clientHeight
		});
	}
	onClickFacebook() {
		const { currentUrl } = this.state;
		this.setState(
			{
				finalURL: `${preURLs.facebook}${currentUrl}`
			},
			() => {
				this.openShareWindow();
			}
		);
	}
	onClickGoogle() {
		const { currentUrl } = this.state;
		this.setState(
			{
				finalURL: `${preURLs.google}${currentUrl}`
			},
			() => {
				this.openShareWindow();
			}
		);
	}

	onClickWhatsapp() {
		const { currentUrl } = this.state;
		this.setState(
			{
				finalURL: `${preURLs.whatsapp}${currentUrl}`
			},
			() => {
				this.openShareWindow();
			}
		);
	}
	onClickTwitter() {
		const { hashtag } = this.props;
		const { currentUrl } = this.state;
		let useHashtag = hashtag || 'React is Super Awesome';
		this.setState(
			{
				finalURL: `${preURLs.twitter}${currentUrl}&hashtags=${useHashtag}`
			},
			() => {
				this.openShareWindow();
			}
		);
	}
	openShareWindow() {
		const { finalURL, windowWidth, windowHeight } = this.state;
		window.open(
			finalURL,
			'shareWindow',
			'height=450, width=550, top=' +
				(windowHeight / 2 - 275) +
				', left=' +
				(windowWidth / 2 - 225) +
				', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0'
		);
	}
	render() {
		return (
			<div className="socialWrapper">
				<div className="shareThisPage">
					<p className="comparte">Comparte</p>
					<div className="iconWrapper">
						<span className="twitter" onClick={this.onClickTwitter}>
							<SVGInline
								svg={`<svg class='icon icon-twitter' id="twitterIcon" fill='#393E42' width='22' height='22' xmlns='http://www.w3.org/2000/svg' viewBox='84 -84 192 192'><path d='M151.8,73.8c57.4,0,88.7-47.5,88.7-88.7c0-1.4,0-2.7-0.1-4c6.1-4.4,11.4-9.9,15.6-16.1c-5.6,2.5-11.6,4.2-17.9,4.9c6.4-3.9,11.4-10,13.7-17.3c-6,3.6-12.7,6.2-19.8,7.6c-5.7-6.1-13.8-9.9-22.8-9.9C192-49.8,178-35.8,178-18.6c0,2.4,0.3,4.8,0.8,7.1c-25.9-1.3-48.8-13.7-64.2-32.6c-2.7,4.6-4.2,10-4.2,15.7c0,10.8,5.5,20.4,13.9,26c-5.1-0.2-9.9-1.6-14.1-3.9c0,0.1,0,0.3,0,0.4c0,15.1,10.8,27.7,25,30.6c-2.6,0.7-5.4,1.1-8.2,1.1c-2,0-4-0.2-5.9-0.6c4,12.4,15.5,21.4,29.1,21.7c-10.7,8.4-24.1,13.3-38.7,13.3c-2.5,0-5-0.1-7.4-0.4C117.8,68.6,134.2,73.8,151.8,73.8'/></svg>`}
							/>
						</span>
						<span className="google" onClick={this.onClickGoogle}>
							<SVGInline
								svg={`<svg class='icon icon-googleplus'  id="googleIcon" fill='#393E42' width='22' height='22' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 192 192'><path d='M8,96.1c-1.1-28.8,24.2-55.5,53-55.8c14.7-1.3,29,4.5,40.2,13.8C96.6,59,92,64,87,68.7c-9.8-6-21.6-10.5-33.1-6.5c-18.5,5.3-29.7,27.1-22.8,45.1c5.7,18.9,28.6,29.2,46.6,21.3c9.3-3.3,15.5-11.9,18.2-21.2c-10.7-0.2-21.4-0.1-32-0.4c0-6.4-0.1-12.7,0-19c17.8,0,35.6-0.1,53.5,0.1c1.1,15.6-1.2,32.2-11.3,44.7c-13.9,17.8-39.5,23.1-60.3,16.1C23.6,141.7,7.6,119.4,8,96.1L8,96.1z'/><path d='M152,72c5.3,0,10.6,0,15.9,0c0,5.3,0.1,10.7,0.1,16c5.3,0.1,10.7,0.1,16,0.1c0,5.3,0,10.6,0,15.9c-5.3,0-10.7,0.1-16,0.1c-0.1,5.3-0.1,10.7-0.1,16c-5.3,0-10.6,0-15.9,0c-0.1-5.3-0.1-10.7-0.1-16c-5.3-0.1-10.7-0.1-16-0.1c0-5.3,0-10.6,0-15.9c5.3,0,10.6-0.1,16-0.1C151.9,82.7,152,77.4,152,72z'/></svg>`}
							/>
						</span>
						<span className="facebook" onClick={this.onClickFacebook}>
							<SVGInline
								svg={`<svg class='icon icon-facebook'  id="faceIcon" fill='#393E42' width='22' height='22' xmlns='http://www.w3.org/2000/svg' viewBox='84 -84 192 192'><path d='M191.8,87.9V18.6h23.3l3.5-27h-26.7v-17.3c0-7.9,2.2-13.1,13.4-13.1h14.3V-63c-2.5-0.3-11-1-20.9-1c-20.6,0-34.8,12.6-34.8,35.7v19.9h-23.3v27h23.3V88L191.8,87.9L191.8,87.9z'/></svg>`}
							/>
						</span>

						<span className="whatsapp" onClick={this.onClickWhatsapp}>
							<SVGInline
								svg={`<svg class='icon icon-whatsapp' fill='#393E42' id="whatsappIcon" viewBox='0 0 32 32' width='22' height='22'><style>.st0{fill-rule:evenodd;clip-rule:evenodd;}</style><path class='st0' d='M24.4 7.5C22.2 5.2 19.2 4 16.1 4 9.6 4 4.3 9.3 4.3 15.8c0 2.1.5 4.1 1.6 5.9l-1.7 6.1 6.2-1.6c1.7.9 3.7 1.4 5.6 1.4 6.5 0 11.8-5.3 11.8-11.8.1-3.2-1.2-6.1-3.4-8.3zm-8.3 18.1c-1.8 0-3.5-.5-5-1.4l-.3-.2-3.7 1 1-3.6-.3-.4c-1-1.6-1.5-3.4-1.5-5.2 0-5.4 4.4-9.8 9.8-9.8 2.6 0 5.1 1 6.9 2.9 1.8 1.8 2.9 4.3 2.9 6.9 0 5.4-4.4 9.8-9.8 9.8zm5.4-7.4c-.3-.1-1.7-.9-2-1-.3-.1-.5-.1-.7.1-.2.3-.8 1-.9 1.2-.2.2-.3.2-.6.1s-1.2-.5-2.4-1.5c-.9-.8-1.5-1.7-1.6-2-.2-.3 0-.5.1-.6.1-.1.3-.3.4-.5.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5-.1-.1-.7-1.6-.9-2.2-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5 0 1.4 1.1 2.8 1.2 3 .1.2 2.1 3.2 5 4.4.7.3 1.2.5 1.7.6.7.2 1.3.2 1.9.1.6-.1 1.7-.7 2-1.4.2-.7.2-1.3.2-1.4-.1 0-.3-.1-.6-.3z' id='WA_Logo'/></svg>`}
							/>
						</span>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Social.js